import {
    Opportunity,
    OpportunityAdditionalAttributes,
} from "@/types/opportunity";
import { IntlShape } from "react-intl";

export function generateOpportunityRewardString(
    opportunity: Opportunity & Pick<OpportunityAdditionalAttributes, "reward">,
    intl: IntlShape,
) {
    let rewardString = intl.formatMessage({ id: opportunity.reward.title });
    if (opportunity.reward.value) {
        rewardString += ` - ${opportunity.reward.value}`;
    } else if (opportunity.reward.description) {
        rewardString += " -";
    }
    if (opportunity.reward.description) {
        rewardString += ` ${opportunity.reward.description}`;
    }
    return rewardString;
}
